<template>
    <v-dialog v-model="shown" lazy absolute content-class="post-actions">
        <slot name="activator" slot="activator"></slot>

        <v-card>
            <v-flex tag="h6">{{sponsorsConstants.DELETE_SPONSOR_ICON}}
                    <v-btn icon  @click.prevent="cancel()" data-qe-id="close_dialog_btn">
                            <v-icon size="20">close</v-icon>
                        </v-btn>
                </v-flex>

                <v-flex tag="p">
                    {{sponsorsConstants.SURE_TO_DELETE}}
                </v-flex>
                <v-flex text-xs-right>
                    <v-btn class="primary_btn transparent small" @click="cancel()" data-qe-id="cancel_dialog_btn" id="cancel_unittest">{{sponsorsConstants.CANCEL}}</v-btn>
                    <v-btn class="primary_btn small" @click="confirm()" data-qe-id="save_dialog_btn" id="save_unittest">{{sponsorsConstants.DELETE}}</v-btn>
                </v-flex>
    
        </v-card>
    </v-dialog>
</template>

<script>
    import { communityCommonConstant } from '@/components/ChapterPage/communityCommon.constant';
    import sponsorsConstants from './sponsors.constant';

    export default {
        name: 'DeleteSponsorDialog',
        data: () => ({
            communityCommonConstant,
            sponsorsConstants,
            shown: false,
        }),
        props: {
            data: {},
        },
        methods: {
            cancel() {
                this.shown = false;
            },
            confirm() {
                this.shown = false;
                this.$emit('confirm', this.data);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '@/common/styles/_colors.scss';
    @import '@/common/styles/_responsive.scss';

    .card {
        &__close-btn {
            margin-top: -5px;
            min-height: 30px !important;
            min-width: 30px !important;
            font-weight: bold !important;
            margin-right: 30px !important;
        }

        &__file-uplod {
           margin-left: -3px;
           margin-top: 5px;
           cursor: pointer; 
        }
    }
    .card-text {
        &__align {
            text-align: left;
            padding-bottom: 10px;
            padding-top: 20px;
        }

        &__width {
            width: 50%;
        } 

        &__toleft {
            margin-left: -1px;
        }
    }

    .card-action {
        &__bottom {
            margin-right: 40px;
            padding-bottom: 30px;
            padding-top: 20px;
        }

        &__text {
            font-size: 20px;
        }
    }

    .icon-rectangle {
        height: 400px;
        width: 745px;
        border-radius: 4px;
        background-color: $white;
    }

    .card-title {
        color: $ypo-cta;

        &__title {
            color: #083050!important;
            font-family: Raleway,serif!important;
            font-size: 18px!important;
            font-weight: 600;
        }

        &__icon {
            margin-left: 20px;
        }
    }

    .path {
        height: 16.67px;
        width: 16.67px;
    }

    .sponsor-logo {
        height: 24px;
        color: $ypo-cta;
        font-family: "Noto Sans";
        font-size: 18px;
        line-height: 24px;
        text-align: left;
        margin-top: 10px;
        width: 180px;

        &__img {
            text-align: center;
            position: relative;
        }

        &__det {
            max-height: 125px;
            margin-left: -400px;
        }
    }

    .closeBtn {
        padding-right: 420px;
        margin-top: -15px;  
        right: -15px;      
    }

    .button-rectangle {
        height: 50px;
        width: 131px;
        border: 1px solid $ypo-gray;
        border-radius: 4px;
        background: linear-gradient(180deg, $ypo-extra-light-gray 0%, $ypo-extra-light-gray 100%);
        box-shadow: inset 0 1px 3px 0 $ypo-blue;
    }

    .link-logo-to {
        height: 24px;
        width: 110px;
        color: $ypo-cta;
        font-family: "Noto Sans";
        font-size: 18px;
        line-height: 24px;
        text-align: right;
    }

    .link-rectangle {
        height: 50px;
        width: 575px;
        border: 1px solid $ypo-gray;
        border-radius: 4px;
    }

    .line-2 {
        border: 1px solid $ypo-gray;
    }

    .rectangle-13-add-button {
        height: 36px;
        width: 96px;
        background-color: $ypo-blue;
    }

    .surface-cancel-button {
        height: 36px;
        width: 96px;
        border-radius: 4px;
        background-color: $ypo-blue;
    }
</style>
